import { useSnackbarContext } from "@repo/contexts/SnackbarContext";
import { useFormValidation } from "@repo/lib/hooks/common";
import {
  deleteAccount,
  globalVerifyOTP,
  logout,
} from "@repo/server-actions/account";
import { useLocale } from "next-intl";
import { useCallback, useState, useTransition } from "react";

const useDeleteAccount = (session) => {
  const [showVerifyOTP, setShowVerifyOTP] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [isPending, startTransition] = useTransition();
  const { formValues, formErrors, setFormErrors, handleValidation } =
    useFormValidation({ email: "" });
  const { setSnackbar } = useSnackbarContext();
  const locale = useLocale();

  const handleVerifyOtp = useCallback(
    (e) => {
      e.preventDefault();
      const payLoad = {
        email: formValues?.email,
        otp: otpValue,
      };
      startTransition(async () => {
        const response = await globalVerifyOTP(payLoad);
        setSnackbar({
          open: true,
          message: response?.message,
          type: response?.success ? "success" : "error",
        });
        if (response?.success) {
          setShowVerifyOTP(false);
          const deleteAccountResponse = await deleteAccount(
            payLoad,
            session,
            response?.token
          );
          setSnackbar({
            open: true,
            message: deleteAccountResponse?.message,
            type: deleteAccountResponse?.success ? "success" : "error",
          });
          if (deleteAccountResponse?.success) {
            await logout(locale);
            setTimeout(() => {
              window.location.assign("/");
            }, 2000);
          }
        }
      });
    },
    [otpValue, formValues?.email, setSnackbar, session, locale]
  );

  return {
    showVerifyOTP,
    otpValue,
    setOtpValue,
    formValues,
    formErrors,
    setFormErrors,
    handleValidation,
    isPending,
    handleVerifyOtp,
    setShowVerifyOTP,
  };
};

export default useDeleteAccount;
